import React from "react";
import { FaFilter } from "react-icons/fa";
import ExpenseCard from "./ExpenseCard";
import styled from "styled-components";
import ToReviewCard from "./ToReviewCard";
import { Notify, Utils } from "../../utils";
import { useSelector } from "react-redux";
import { useAppSelector } from "../../_app";
import { ExpenseService } from "../../_service/ExpenseService";
import exp from "constants";

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 1rem;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: bold;
  color: #000000;
  font-size: 1.1rem;

  span {
    color: #28a745;
    margin-left: 0.3rem;
  }
`;
const Avatar = styled.div<{ bg?: string }>`
  background: ${({ bg }) => bg || "rgb(230, 230, 250)"};
  color: gray;
  font-weight: bold;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
`;

const StyledInviteButton = styled.p`
  font-size: 14px;
  border: 1px solid #28a745;
  background-color: #28a745;
  color: #ffffff;
  padding: 0.425rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 400;
  transition: all 0.3s ease;
  margin: 0;

  &:hover {
    background-color: #218838;
    border-color: #218838;
    transform: scale(1.01);
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  button {
    border: 1px solid #28a745;
    background: #ffffff;
    color: white;
    padding: 0.4rem 1rem;
    border-radius: 4px;
    cursor: pointer;

    &:first-child {
      border-color: #28a745;
      color: #28a745;
      display: flex;
      align-items: center;
      gap: 0.3rem;
    }
  }
`;

interface Expense {
  id: number;
  purchase_amount: number;
  description: string;
  spent_at: string;
  spent_on: string;
  status:
    | "submitted"
    | "rejected"
    | "approved"
    | "paid"
    | "declined"
    | "non_reimbursable";
  is_reimbursable: boolean;
  category?: string;
  decline_reason?: string;
  employee: {
    id: number;
    name: string;
  };
  bgColor: any;
}

interface RawData {
  [employeeId: string]: {
    employee_data: { id: number; name: string };
    expense_data: any[];
  };
}

interface ToReviewProps {
  data?: RawData;
  bgColor?: any;
}

const ToReview: any = ({ data, refetchToReviewExpenseClaims, openExpense }) => {
  // Flatten the nested structure
  const allExpenses: Expense[] = [];

  Object.entries(data || {}).forEach(([_, employeeBlock]:any) => {
    employeeBlock?.expense_data.forEach((exp) => {
      allExpenses.push({
        ...exp,
        employee: {
          id: employeeBlock?.employee_data.id,
          name: employeeBlock?.employee_data.name,
        },
      });
    });
  });

  // Logic - Filter failed approvals
  const failedToApproveData = allExpenses.filter(
    (e) => e.status === "rejected"
  );

  let sumOfFailedToApprove = failedToApproveData.reduce(
    (acc, curr) => acc + curr.purchase_amount,
    0
  );

  // Example: Filter for "James Hudson" as current user
  const yourExpensesData = allExpenses.filter(
    (e) => e.employee.name === "James Hudson"
  );

  const totalAmount = yourExpensesData
    .reduce((acc, curr) => acc + curr.purchase_amount, 0)
    .toFixed(2);
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((n) => n?.[0])
      .join("");
  };

  const [isLoading, setIsLoading] = React.useState(false);

  const companyId = useAppSelector((state: any) => state.user.defaultCompnayId);

  const allExpenseIdsWithStatusSubmitted = allExpenses
    .filter((e) => e.status === "submitted")
    .map((e) => e.id);

  const onApprove = async (expenseId, isBulk=false) => {
    console.log("Expense Id to approve:", expenseId);
    setIsLoading(true);
    let payload = {
      company: companyId,
      claim_ids: isBulk ? [...allExpenseIdsWithStatusSubmitted] : [expenseId],
    };
    console.log("Form submitted:", payload);

    try {
      const { status } = await ExpenseService._approveExpenseClaim(payload);
      if (status >= 200 && status < 300) {
        Notify(isBulk ? `All claims approved successfully!` : `Claim approved successfully!`, 1);
        refetchToReviewExpenseClaims();

        setIsLoading(false);
      }
    } catch (error: any) {
      Utils.showErrorMessage(error);
      setIsLoading(false);
    }
  };

  const onReject = async (expenseId) => {
    setIsLoading(true);

    try {
      const { status } = await ExpenseService._rejectExpenseClaim(expenseId);
      if (status >= 200 && status < 300) {
        Notify(`Claim rejected!`, 1);
        setIsLoading(false);
        refetchToReviewExpenseClaims();
      }
    } catch (error: any) {
      Utils.showErrorMessage(error);
      setIsLoading(false);
    }
  };

  console.log('All expense Ids with status "submitted":', allExpenseIdsWithStatusSubmitted);

  // const ToReview: React.FC<ToReviewProps> = ({ data }) => {
  if (!data) return null;

  return (
    <div style={{ maxWidth: "85%", margin: "auto" }}>
      {Object.keys(data).length === 0 ? (
      <div style={{ textAlign: "center", padding: "3rem", color: "#777" }}>
        <h3>No claims to review</h3>
        <p>There are currently no expense claims pending review.</p>
      </div>
      ) : (
      <>
        <Header>
        <Title>{/* All <span>({data.length})</span> */}</Title>
        {/* <ButtonGroup>
        <button>
        <FaFilter /> Filter
        </button>
        </ButtonGroup> */}
        </Header>
        <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "1rem",
          fontWeight: 600,
          fontSize: "1rem",
          margin: "2rem 0 1rem 0",
          justifyContent: "space-between",
        }}
        >
        <span>
          Failed to approve{" "}
          <span style={{ color: "#28a745", marginLeft: "0.3rem" }}>
          ({failedToApproveData.length})
          </span>
        </span>

        {sumOfFailedToApprove > 0 && (
          <span style={{ color: "#28a745" }}>
          ${sumOfFailedToApprove.toFixed(2)}
          </span>
        )}
        </div>

        <div style={{ marginBottom: "2.5rem" }}>
        {failedToApproveData.length > 0 ? (
          failedToApproveData
          .filter((expense) => expense.status === "rejected")
          .map((expense, index) => (
            <ToReviewCard
            key={expense.id}
            data={expense}
            onApprove={(id) => onApprove(id)}
            onReject={(id) => onReject(id)}
            bgColor={
              Utils.LIGHT_COLOR_CODES[
              index % Utils.LIGHT_COLOR_CODES.length
              ]
            }
            openExpense={openExpense}
            />
          ))
        ) : (
          <div style={{ textAlign: "center", padding: "2rem", color: "#777" }}>
          No rejected claims to display
          </div>
        )}
        </div>

        {Object.entries(data)
        .filter(
          ([_, { expense_data }]:any) =>
          expense_data.filter((exp) => exp.status !== "rejected").length > 0
        )
        .map(([_, { employee_data, expense_data }]:any) => (
          <div key={employee_data.id} style={{ marginBottom: "2rem" }}>
          {/* Employee Name Header */}
          <Header>
            <Title>
            <Avatar>{getInitials(employee_data.name)}</Avatar>
            {employee_data.name}{" "}
            <span>
              (
              {
              expense_data.filter((exp) => exp.status !== "rejected")
                .length
              }
              )
            </span>
            </Title>

            <StyledInviteButton onClick={() => onApprove(null, true)}>
            Approve all - $
            {expense_data
              .filter(
              (exp) =>
                exp.status === "submitted" && exp.status !== "rejected"
              )
              .reduce((acc, curr) => acc + curr.purchase_amount, 0)
              .toFixed(2)}
            </StyledInviteButton>
          </Header>

          {/* Expense Cards */}
          {expense_data
            .filter((exp) => exp.status !== "rejected")
            .map((expense, index) => (
            <ToReviewCard
              key={expense.id}
            onApprove={(id) => onApprove(id)}
            onReject={(id) => onReject(id)}
              data={{
              ...expense,
              employee: {
                id: employee_data.id,
                name: employee_data.name,
              },
              }}
              bgColor={
              Utils.LIGHT_COLOR_CODES[
                index % Utils.LIGHT_COLOR_CODES.length
              ]
              }
              openExpense={openExpense}
            />
            ))}
          </div>
        ))}
      </>
      )}
    </div>
  );
};

export default ToReview;
